import React from 'react';
import PropTypes, { InferProps } from 'prop-types';

import TabInterface from '@COMPONENTS/SHARED/TabInterface';
import {
    useGetSystemSettingsQuery,
} from '@SERVICES';
import SystemSettingsTab from '../SystemSettingsTab/index';
import WorkspaceManagementTab from '../WorkspaceManagementTab/index';

function EnhancedContent() {
    const { data: systemSettings, isLoading } = useGetSystemSettingsQuery();

    if (isLoading) {
        return <div>Loading system settings...</div>;
    }

    if (!systemSettings) {
        return <div>Unable to load system settings. Please try again.</div>;
    }

    const tabs = [
        {
            id: 'system-settings',
            label: 'System Configuration',
            content: <SystemSettingsTab systemSettingsData={systemSettings} />,
        },
        {
            id: 'workspace-management',
            label: 'Workspace Management',
            content: <WorkspaceManagementTab />,
        },
    ];

    return (
        <div className="content-wrapper">
            <TabInterface tabs={tabs} />
        </div>
    );
}

export default EnhancedContent; 